export default __webpack_public_path__ + "static/1-8888c4f36d4e69fdbc03a7867c586d11.jpg";